import { render, staticRenderFns } from "./MdPatientMedicationsOutCome.vue?vue&type=template&id=2b9b35e2&"
import script from "./MdPatientMedicationsOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPatientMedicationsOutCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports